import React from 'react';
import PropTypes from 'prop-types';
import {formatMoney} from '@shopify/theme-currency';

import {imageUrl} from '../../../../assets/scripts/utils/shopify-images';

const SearchResult = ({result, type, moneyFormat, searchTerm}) => {
  const searchTermLowerCase = searchTerm.toLowerCase();
  const isProduct = type === 'product';

  let resultTitle = result.title;

  if (!isProduct) {
    const resultTitleLowercase = resultTitle.toLowerCase();
    resultTitle = resultTitleLowercase.replaceAll(searchTermLowerCase, `<span>${searchTermLowerCase}</span>`);
  }

  return (
  <>
    <div key={result.id} className="quick-search-results__cell">
      {isProduct && result?.featured_image?.url && (
        <a href={result.url} className="aspect-ratio aspect-ratio--square">
          <img
            src={imageUrl(result.featured_image.url, 600)}
            width={result.featured_image.width}
            height={result.featured_image.height}
            alt={result.featured_image.alt}
            className="quick-search-results__image"
          />
        </a>
      )}
      <h4 className="quick-search-results__title h6">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a href={result.url} dangerouslySetInnerHTML={{__html: resultTitle}} />
      </h4>
      {result.price && (
        <p className="quick-search-results__price">
          <span className="money">{formatMoney(result.price, moneyFormat)}</span>
        </p>
      )}
    </div>
  </>
)};

SearchResult.propTypes = {
  result: PropTypes.object,
  type: PropTypes.string,
  moneyFormat: PropTypes.string.isRequired,
  searchTerm: PropTypes.string
};

export default SearchResult;
